import React from 'react';

const CallToAction = () => {
  return (
    <div className="bg-purple-600 text-white text-center py-20">
      <h2 className="text-3xl font-bold mb-2">
        Ready to start discovering meals?
      </h2>
      <p className="mb-6">Join ChowBuddy on Telegram and get started today!</p>
      <a
        href="https://t.me/ChowBuddyBot"
        className="bg-white text-purple-600 px-8 py-3 rounded-full font-semibold hover:bg-gray-100 transition duration-300"
        target="_blank"
        rel="noopener noreferrer"
      >
        Start Chatting
      </a>
    </div>
  );
};

export default CallToAction;
